<template>
	<div class="content">
		<LayoutBanner />

		<div v-loading="loading" class="news_info min_cw ql-snow">
			<div class="top">
				<p class="date">{{ infoData.create_time }}</p>
				<h2 class="title">{{ infoData.news_title }}</h2>
			</div>

			<div class="con ql-editor" v-html="infoData.news_content"></div>

			<ul v-if="fileList.length > 0" class="file_list">
				<li v-for="(item, index) in fileList" :key="index">
					<img :src="$import('file_icon.png')" alt="">
					<span class="title" @click="handleDownload(item, index)">{{ item.name }}</span>
				</li>
			</ul>

			<div class="bottom">
				<div class="btn prev">
					<p v-if="prev">上一篇：<span @click="handlePrev">{{ prev.news_title }}</span></p>
				</div>
				<div class="btn next">
					<p v-if="next">下一篇：<span @click="handleNext">{{ next.news_title }}</span></p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import LayoutBanner from "@/components/Layout/banner";
import {getNewsInfoApi} from "@/api";
import {downloadFile} from "@/utils/application";
import {Message} from "element-ui";

export default {
	name: "index",
	components: {
		LayoutBanner,
	},
	data() {
		return {
			loading: false,
			infoData: {},

			fileList: [],
			fileLoading: false,

			prev: null,
			next: null,
		}
	},
	watch: {
		"$route.fullPath"() {
			this.init();
		}
	},
	created() {
		this.init();
	},
	methods: {
		async init() {
			this.reset();
			this.loading = true;

			const { data } = await getNewsInfoApi(this.$route.params.id);
			this.infoData = data.newsInfo;

			let fileList = data.newsInfo && data.newsInfo.news_file ? data.newsInfo.news_file.split(",") : [];
			let fileNameList = data.newsInfo && data.newsInfo.file_name ? data.newsInfo.file_name.split(",") : [];
			if( fileList.length > 0 && fileNameList.length > 0 ) {
				fileList.forEach((path, index) => {
					this.fileList.push({
						name: fileNameList[index],
						url: this.$http.fileUrl + path,
					})
				})
			}

			this.prev = data.previousnewsInfo;
			this.next = data.nextnewsInfo;

			this.loading = false;
		},

		reset() {
			this.infoData = {};
			this.fileList = [];
			this.prev = null;
			this.next = null;
		},

		/**
		 * 下载文件
		 */
		async handleDownload(item, index) {
			this.fileLoading = true;
			try {
				await downloadFile(item.url, item.name);
				this.fileLoading = false;
			}
			catch (e) {
				this.fileLoading = false;
				Message.error("无效的类型");
				// this.$modal.msgError("下载失败");
			}
		},

		/**
		 * 上一篇
		 */
		handlePrev() {
			if(this.prev) {
				this.$router.push("/news/" + this.prev.news_id);
			}
		},

		/**
		 * 下一篇
		 */
		handleNext() {
			if(this.next) {
				this.$router.push("/news/" + this.next.news_id);
			}
		},
	}
}
</script>

<style lang="less" scoped>
.news_info {
	padding: 60px 40px;

	.top {
		margin-bottom: 50px;

		.date {
			font-size: 22px;
			color: @gray;
			margin-bottom: 10px;
		}

		.title {
			font-size: 22px;
			color: @blackLine;
			line-height: 1.6;
		}
	}

	.bottom {
		width: 100%;
		display: flex;
		justify-content: space-between;
		padding-top: 45px;
		margin-top: 45px;
		border-top: 1px solid @greyLine;

		.btn {
			flex-shrink: 0;
			width: calc(50% - 20px);
			.ellipsis;
			font-size: 14px;
			color: #666666;
		}

		span {
			cursor: pointer;
		}

		span:hover {
			color: @red;
		}

		.next {
			text-align: right;
		}
	}

	.file_list {
		width: 100%;
		margin-top: 50px;

		>li {
			display: flex;
			align-items: center;
		}

		img {
			flex-shrink: 0;
			width: 16px;
			margin-right: 10px;
		}

		.title {
			font-size: 14px;
			color: @gray;
			.ellipsis;
			line-height: 1.6;
			cursor: pointer;
		}

		.title:hover {
			color: @red;
		}
	}
}
</style>
